import _typeof from "@babel/runtime/helpers/esm/typeof";
var isTypeOf = function isTypeOf(type) {
  return function (value) {
    return _typeof(value) === type;
  };
};
export default isTypeOf;